// extracted by mini-css-extract-plugin
export default {"buttonWithIcon":"button-with-icon__button-with-icon__pcfde","icon":"button-with-icon__icon__Gsckr"};